import styled from 'styled-components';
//import shadowBg from '../../utils/assets/shadow-bg.png';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${props => (props.justifyContent ? props.justifyContent : 'center')};
  align-items: ${props => (props.alignItems ? props.alignItems : '')};
  min-height: 137px;
  margin: 20px 0 40px;
  background-color: rgb(102, 102, 102);
  &.teamId-4 {
    background-color: #FF2800;
  }
  &.teamId-3 {
    background-color: #021b32;
  }
  &.teamId-2 {
    background-color: #5cf1e4;
  }
  background-image: url("https://images2.gazzettaobjects.it/assets-mc/bkg/shadow-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  image-rendering: auto;
  image-rendering: crisp-edges;
  ${props => props.theme.mediaQueries.tablet_big_down}{
      min-height: 170px;
      margin: 30px 0 30px;
      background-size: auto;
      background-position: top;
  }
`;

export const CentralWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${props => (props.justifyContent ? props.justifyContent : 'baseline')};
  margin-top: 0.8em;
  margin-bottom: 20px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    margin-top: 4em;
  };
`;

export const CentralInternalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.6em;
  justify-content: center;
  margin-bottom: ${props => (props.isLast ? '20px' : '0px')};
  ${props => props.theme.mediaQueries.tablet_big_down}{
   flex-direction: column;
  };
`;

export const BookmarkWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;

 ${props => props.theme.mediaQueries.tablet_big_down}{
  top: 10px;
  right: 10px;
 };
`;

export const HeaderShadow = styled.span`
    position: absolute;
    top: ${props => (props.isMobile ? '145px' : '97px')};
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
`;

export const ContentWrapper = styled.div`
  flex: ${props => (props.flex ? props.flex : '')};
  display: ${props => (props.display ? props.display : '')};
  justify-content: ${props => (props.justifyContent ? props.justifyContent : '')};
`;


/*
 display: flex;
 justify-content: ${props => (props.justifyContent ? props.justifyContent : 'center')};
 align-items: ${props => (props.alignItems ? props.alignItems : 'center')};;
 width: ${props => (props.width ? props.width : '')} */



// WEBPACK FOOTER //
// ./src/lib/components/DriverHeader/styles.js